import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            影视资讯
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            最新国产影视动态与深度内容推荐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 6).map((card) => (
            <a
              key={card.id}
              href="#carousel"
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full aspect-[16/9] object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      const placeholder = parent.querySelector('.img-placeholder');
                      if (placeholder) (placeholder as HTMLElement).style.display = 'flex';
                    }
                  }}
                />
                <div className="img-placeholder hidden w-full aspect-[16/9] bg-background-200 flex items-center justify-center">
                  <i className="ri-image-line text-3xl text-foreground-400"></i>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">{card.tag}</span>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">{card.title}</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed flex-1">{card.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600 font-medium whitespace-nowrap group-hover:gap-2 transition-all">
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6">
          <a
            key={cardsData[6].id}
            href="#carousel"
            className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-300 overflow-hidden transition-all duration-200 cursor-pointer flex flex-col lg:flex-row"
          >
            <div className="lg:w-[400px] flex-shrink-0 relative overflow-hidden">
              <img
                src={cardsData[6].image}
                alt={cardsData[6].title}
                className="w-full lg:w-[400px] h-48 lg:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    const placeholder = parent.querySelector('.img-placeholder-featured');
                    if (placeholder) (placeholder as HTMLElement).style.display = 'flex';
                  }
                }}
              />
              <div className="img-placeholder-featured hidden w-full h-48 lg:h-full bg-background-200 flex items-center justify-center">
                <i className="ri-image-line text-3xl text-foreground-400"></i>
              </div>
            </div>
            <div className="p-5 md:p-6 flex-1 flex flex-col justify-center">
              <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-md w-fit whitespace-nowrap">{cardsData[6].tag}</span>
              <h3 className="mt-3 text-base md:text-lg font-semibold text-foreground-900 leading-snug">{cardsData[6].title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{cardsData[6].desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-accent-600 font-medium whitespace-nowrap group-hover:gap-2 transition-all">
                阅读全文 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}